import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=4cd69e13&scoped=true&"
import script from "./VideoPreview.vue?vue&type=script&lang=js&"
export * from "./VideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=4cd69e13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd69e13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd69e13')) {
      api.createRecord('4cd69e13', component.options)
    } else {
      api.reload('4cd69e13', component.options)
    }
    module.hot.accept("./VideoPreview.vue?vue&type=template&id=4cd69e13&scoped=true&", function () {
      api.rerender('4cd69e13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/familyMotto/comp/VideoPreview.vue"
export default component.exports